var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "community-hc-image" },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAdd } },
            [_vm._v("添加轮播图")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadConfig } },
            [_vm._v("查询")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.list, border: "", height: "500" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80", fixed: "" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "title", label: "主题名称", "min-width": "180" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "封面", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "cover-box" }, [
                      scope.row.url
                        ? _c("img", {
                            staticClass: "cover-img",
                            attrs: { src: _vm.getImageUrl(scope.row.url) },
                          })
                        : _c("i", {
                            staticClass: "el-icon-picture-outline cover-icon",
                          }),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "startTime", label: "开始时间", "min-width": "135" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "endTime", label: "结束时间", "min-width": "135" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "desc", label: "说明", "min-width": "200" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "type",
              label: "类型",
              width: "90",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.type === "link" ? "链接" : "普通")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "signUp",
              label: "报名",
              width: "75",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.signUp ? "是" : "否")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "detailImages",
              label: "详情图",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "detail-img-list" },
                      [
                        _vm._l(
                          scope.row.detailImages || [],
                          function (img, idx) {
                            return img
                              ? _c("img", {
                                  key: idx,
                                  staticClass: "detail-thumb",
                                  attrs: { src: _vm.getImageUrl(img) },
                                })
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        !(
                          scope.row.detailImages &&
                          scope.row.detailImages.length
                        )
                          ? _c("span", [_vm._v("-")])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "onShelf",
              label: "显示",
              width: "75",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisible(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "140",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(scope.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetForm,
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "setting-card", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                { staticClass: "card-content" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      staticClass: "beautify-form",
                      attrs: {
                        model: _vm.formData,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("基础信息"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题名称", prop: "title" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入主题名称",
                              clearable: "",
                            },
                            model: {
                              value: _vm.formData.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "title", $$v)
                              },
                              expression: "formData.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "上传封面", prop: "url" } },
                        [
                          _c("div", { staticClass: "image-uploader" }, [
                            _c(
                              "div",
                              {
                                staticClass: "image-preview small",
                                on: { click: _vm.triggerSelect },
                              },
                              [
                                _vm.formData.url
                                  ? _c("img", {
                                      staticClass: "preview-img",
                                      attrs: {
                                        src: _vm.getImageUrl(_vm.formData.url),
                                      },
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "image-placeholder" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "placeholder-text" },
                                          [_vm._v("点击上传图片")]
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              ref: "fileInput",
                              staticStyle: { display: "none" },
                              attrs: { type: "file", accept: "image/*" },
                              on: { change: _vm.handleFileChange },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "image-hint" }, [
                              _vm._v("建议尺寸：332px * 500px"),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("时间设置"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间", prop: "dateRange" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.formData.dateRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "dateRange", $$v)
                              },
                              expression: "formData.dateRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("内容设置"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "说明信息", prop: "desc" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "3",
                              placeholder: "请输入说明信息",
                            },
                            model: {
                              value: _vm.formData.desc,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "desc", $$v)
                              },
                              expression: "formData.desc",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型", prop: "type" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleTypeChange },
                              model: {
                                value: _vm.formData.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "type", $$v)
                                },
                                expression: "formData.type",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "normal" } }, [
                                _vm._v("普通"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "link" } }, [
                                _vm._v("链接"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.formData.type === "link"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "URL", prop: "urlInput" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入链接地址",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.formData.urlInput,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "urlInput", $$v)
                                  },
                                  expression: "formData.urlInput",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.type === "normal"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "报名", prop: "signUp" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.signUp,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "signUp", $$v)
                                    },
                                    expression: "formData.signUp",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("否"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("是"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formData.type === "normal"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: "详情图", prop: "detailImages" },
                            },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "detail-upload",
                                  attrs: {
                                    action: "",
                                    "auto-upload": false,
                                    "list-type": "picture-card",
                                    "file-list": _vm.detailFiles,
                                    "on-change": _vm.handleDetailImageChange,
                                    "on-remove": _vm.handleDetailImageRemove,
                                    "on-preview": _vm.handleDetailImagePreview,
                                    limit: 5,
                                    "http-request": function () {},
                                    accept: "image/*",
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-plus" })]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-hint" }, [
                                _vm._v(
                                  "注：产品细节图、产品场景图，图片尺寸限制1M内。"
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-title" }, [
                        _vm._v("显示设置"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "显示", prop: "onShelf" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.formData.onShelf,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "onShelf", $$v)
                                },
                                expression: "formData.onShelf",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("未启用"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("启用"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "sort" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              min: 1,
                              max: 9999,
                              "controls-position": "right",
                            },
                            model: {
                              value: _vm.formData.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "sort", $$v)
                              },
                              expression: "formData.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer beautify-btns",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "预览社区图片",
            width: "600px",
            "before-close": _vm.handlePreviewClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "preview-dialog-content" }, [
            _c("img", {
              staticClass: "preview-image",
              staticStyle: {
                "max-width": "100%",
                height: "auto",
                display: "block",
                margin: "0 auto",
              },
              attrs: { src: _vm.previewImageUrl, alt: "预览图片" },
            }),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }